module.exports = __webpack_public_path__ + "img/slide-00.b9c39adf.jpg";